import translations from '../../components/location/ts/es-MX';
import { registerLocale } from '../../components/location/localeStrings';

registerLocale('es-MX', translations);
